<div class="hpanel card-panel contact-panel "
  [ngClass]="{'deactivated': BusinessDataInput?.status=='INACTIVE' && BusinessDataInput?.isSuperAdmin==false,'deactivatedaa':BusinessDataInput.status=='BLOCKED'}"
  style="margin-bottom: 5px;">
  <div class="panel-body min-ht-12-1 cp border-radius-top-left-right-6 border-radius-bottom-left-right-0"
    [ngClass]="{'deactivated': BusinessDataInput?.status=='INACTIVE' && BusinessDataInput?.isSuperAdmin==false,'deactivatedaa':BusinessDataInput.status=='BLOCKED'}"
    style="padding-top: 1rem;">
    <button *ngIf="BusinessDataInput.connectionStatus === 'REQUEST_RECEIVED'" style="margin-right:4px;"
      class="btn btn-primary pull-right btn-xs action-btn accept-request-btn"
      (click)="opencontactmodal(businessDetails?.id); $event.stopPropagation();">
      Accept Request
    </button>
    <button *ngIf="From === 'MEMBER_NETWORK' && BusinessDataInput.connectionStatus === 'PENDING'"
      style="margin-right:4px;" class="btn btn-primary pull-right btn-xs action-btn accept-request-btn"
      (click)="connectionrequest(BusinessDataInput , 'ACCEPT'); $event.stopPropagation();">
      Accept Request
    </button>
    <button *ngIf="BusinessDataInput.connectionStatus === 'REQUEST_SENT'&&role!='EMPLOYEE'" style="margin-right:4px;"
      class="btn btn-primary pull-right btn-xs action-btn cancel-request-btn "
      (click)="handleInvite(BusinessDataInput,'CANCEL'); $event.stopPropagation();">
      Cancel Request
    </button>

    <button *ngIf="['CONNECTED', 'INACTIVE'].includes(BusinessDataInput.connectionStatus)" style="margin-right:4px;"
      (click)="sendMessage(BusinessDataInput)" class="btn btn-primary pull-right btn-xs action-btn">
      Send Message
      <ng-icon name="tablerMail" class="jwsk gs-icon-action" *ngIf="['CONNECTED', 'INACTIVE'].includes(BusinessDataInput.connectionStatus)"
        aria-hidden="true"></ng-icon>
    </button>
    <div class="iconAliment">

    </div>
    <div class="plazxzl">
      <img alt="logo"
        [ngClass]="{'deactivated': BusinessDataInput?.status=='INACTIVE' && BusinessDataInput?.isSuperAdmin==false,'deactivatedaa':BusinessDataInput.status=='BLOCKED'}"
        class="img-circle m-b mb-15 Bphoto" src="{{url+ BusinessDataInput.businessLogo }}"
        onerror="this.src='assets/images/gallery/company.png';" />

      <div class="oyoyo">
        <img *ngIf="BusinessDataInput?.status=='INACTIVE'"
          [ngClass]="{'deactivated': BusinessDataInput?.status=='INACTIVE' && BusinessDataInput?.isSuperAdmin==false,'deactivatedaa':BusinessDataInput.status=='BLOCKED'}"
          height="25px" src="assets/icon/Blocked-PNG-File.png" alt="">
        <p *ngIf="BusinessDataInput?.status=='INACTIVE'">Deactivated</p>
        <p *ngIf="BusinessDataInput?.status=='BLOCKED'">Blocked</p>
      </div>
    </div>


    <div *ngIf="BusinessDataInput.connectionStatus != 'REQUEST_SENT'&&role!='EMPLOYEE'" class="iewbdl" [id]="dropdownId"
      dropdown (isOpenChange)="onDropdownToggle($event)" (click)="$event.stopPropagation();">
      <a id="button-animated" dropdownToggle class="m-r-10">
        <img src="assets/icon/icon-vert-thr-dot.png" alt="" height="25px" srcset="" class="vert-three-dot-icon">
      </a>
      <ul id="dropdown-animated" id="the-dropdowns" *dropdownMenu class="dropdown-menu zloipfhh m-l-81" role="menu"
        aria-labelledby="button-animated">
        <li *ngIf="From === 'MEMBER_NETWORK'&&['CONNECTED', 'INACTIVE'].includes(BusinessDataInput.connectionStatus)"
          role="menuitem" dropdown>
          <a class="dropdown-item common-font-12 padd" dropdownToggle
            (click)="removememberContact(BusinessDataInput.businessId);$event.stopPropagation();">Remove Contact</a>
        </li>
        <li *ngIf="From != 'MEMBER_NETWORK'&&['CONNECTED', 'INACTIVE'].includes(BusinessDataInput.connectionStatus)"
          role="menuitem" dropdown>
          <a class="dropdown-item common-font-12 padd" dropdownToggle
            (click)="removeUserContact(BusinessDataInput);$event.stopPropagation();">Remove Contact</a>
        </li>
        <li *ngIf="BusinessDataInput.connectionStatus === 'REQUEST_RECEIVED'" role="menuitem" dropdown>
          <a class="dropdown-item common-font-12 padd" dropdownToggle
            (click)="handleInvite(BusinessDataInput,'REJECT'); $event.stopPropagation();">Reject Request</a>
        </li>
        <li *ngIf="From === 'MEMBER_NETWORK' && BusinessDataInput.connectionStatus === 'PENDING'" role="menuitem"
          dropdown>
          <a class="dropdown-item common-font-12 padd" dropdownToggle
            (click)="connectionrequest(BusinessDataInput , 'REJECT'); $event.stopPropagation();">Reject Request</a>
        </li>
      </ul>
    </div>
    <div class="business-profile" (click)="businessprofile(BusinessDataInput);">
      <h6 class="card-title cardEillpise fw-bold mb-3 spacing" data-toggle="tooltip" data-placement="top"
        title="{{BusinessDataInput.businessName}}" [ngClass]="{
          'deactivated': BusinessDataInput?.status == 'INACTIVE' && !BusinessDataInput?.isSuperAdmin,
          'deactivatedaa': BusinessDataInput.status == 'BLOCKED'
        }">
        {{ BusinessDataInput.businessName }}
      </h6>

      <div class="info-group">
        <p *ngIf="'BusinessDataInput?.companyLocationDetails?[0]!=null'" title="{{ BusinessDataInput?.companyLocationDetails?.[0]?.state }},
        {{ BusinessDataInput?.companyLocationDetails?.[0]?.country }}"
          class="d-flex align-items-center common-font-11 mb-2 ellipsses">
          <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>

          <span class="ellipsses">
            {{ BusinessDataInput?.companyLocationDetails?.[0]?.state }},
            {{ BusinessDataInput?.companyLocationDetails?.[0]?.country }}
          </span>
        </p>
        <p *ngIf="BusinessDataInput?.companyLocationDetails?.[0]?.businessPhone"
          title="{{ BusinessDataInput?.companyLocationDetails?.[0]?.businessPhone || 'N/A' }}"
          class="d-flex align-items-center common-font-11 mb-2 ellipsses">
          <ng-icon name="tablerPhone" class="svg-position"></ng-icon>
          <span class="ellipsses">
            {{ BusinessDataInput?.companyLocationDetails?.[0]?.businessPhone || 'N/A' }}
          </span>
        </p>
        <p title="{{BusinessDataInput.businessEmail}}"
          class="d-flex cardEillpise align-items-center common-font-11 mb-2 ellipsses">
          <ng-icon name="tablerMail" class="svg-position"></ng-icon>
          <span class="ellipsses">
            {{ BusinessDataInput.businessEmail }}
          </span>
        </p>
        <p title="{{ BusinessDataInput?.companyLocationDetails?.[0]?.website || 'N/A' }}"
          *ngIf="BusinessDataInput?.companyLocationDetails?.[0]?.website"
          class="d-flex align-items-center common-font-11 ellipsses">
          <ng-icon name="tablerWorld" class="svg-position"></ng-icon>
          <span class="ellipsses">
            {{ BusinessDataInput?.companyLocationDetails?.[0]?.website || 'N/A' }}
          </span>
        </p>
      </div>
    </div>






  </div>
  <div class="panel-footer cardpanelfooter border-radius-top-left-right-0 lsjdo contact-footer footPadding">
    <div class="equal-spacing">
      <div class="col-md-3 p-0">
        <div class="contact-stat">
          <span>Members </span>
          <strong>{{ BusinessDataInput.employeesCnt }}</strong>
          <strong *ngIf=" BusinessDataInput?.employeesCnt === null ">0</strong>
          <strong *ngIf=" BusinessDataInput?.employeesCnt === undefined ">0</strong>
        </div>
      </div>
      <div class="col-md-3 p-0">
        <div class="contact-stat">
          <span>Followers </span>
          <strong>{{ BusinessDataInput.followersCnt }}</strong>
          <strong *ngIf=" BusinessDataInput?.followersCnt === null ">0</strong>
          <strong *ngIf=" BusinessDataInput?.followersCnt === undefined ">0</strong>
        </div>
      </div>
      <div class="col-md-3 p-0">
        <div class="contact-stat">
          <span>Jobs </span>
          <strong>{{ BusinessDataInput.jobsCount }}</strong>
          <strong *ngIf=" BusinessDataInput.jobsCount === null ">0</strong>
          <strong *ngIf=" BusinessDataInput.jobsCount === undefined ">0</strong>
        </div>
      </div>
      <div class="col-md-3 p-0">
        <div class="contact-stat">
          <span>Candidates </span>
          <strong>{{ BusinessDataInput.candidatesCount }}</strong>
          <strong *ngIf=" BusinessDataInput.candidatesCount === null ">0</strong>
          <strong *ngIf=" BusinessDataInput.candidatesCount === undefined ">0</strong>
        </div>
      </div>
    </div>
  </div>
</div>

<app-common-modal *ngIf="showModal"
  [b2bnetworkcarddata]="{ email: BusinessDataInput.businessEmail, id: businessDetails.id}" [title]="selectedItem"
  [type]="'ADD'" [businessDetails]="combinedBusinessDetails" (response)="closeModal($event)"></app-common-modal>